import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import DefaultLayout from '../Layouts/DefaultLayout';

import DownloadCategory from '../Components/DownloadCategory';

function App() {
    const [typeDownload, setTypeDownload] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const { tipo } = useParams();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchTypeDownload = async () => {
            let redirected = false;

            try {
                const response = await fetch(`${baseUrl}/painel/tipos-downloads/${tipo}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (!response.ok) {
                    if (response.status === 404) {
                        navigate('/painel/', {
                            state: {
                                message: { type: 'error', text: 'Categoria não encontrada!' },
                            },
                        });
                        redirected = true;
                        return;
                    }
                    throw new Error('Erro ao buscar a categoria.');
                }

                const data = await response.json();
                setTypeDownload(data.tipo_download);
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            } finally {
                if (!redirected) {
                    setLoading(false);
                }
            }
        };

        fetchTypeDownload();
    }, [tipo]);

    return (
        <DefaultLayout>
            <div className="pb-4 md:pb-6 2xl:pb-10">
                <div className="grid grid-cols-12 gap-4 md:gap-6">
                    <div className="col-span-12">
                        <div className="relative z-[1] mb-10 md:mb-16 xl:mb-20 before:content-[''] before:absolute before:top-0 before:bottom-0 before:w-screen before:left-1/2 before:bg-quaternary before:-translate-x-1/2 before:-z-[1]">
                            <div className="flex flex-col py-5 md:py-10">
                                <h4 className="text-sm md:text-base lg:text-lg text-white font-medium uppercase tracking-wider -mb-2">
                                    Downloads
                                </h4>
                                <h2 className="max-sm:text-2xl max-lg:text-4xl max-md:mt-2 lg:text-[44px] text-secondary font-semibold">
                                    {typeDownload.nome}
                                </h2>
                            </div>
                        </div>

                        {loading && (
                            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 xl:gap-10 opacity-20">
                                {[...Array(4)].map((_, index) => (
                                    <div
                                        key={index}
                                        role="status"
                                        className="flex items-center justify-center h-0 pb-[90%] md:pb-[103%] max-w-sm bg-gray-300 rounded-lg animate-pulse dark:bg-gray-700"
                                    >
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                ))}
                            </div>
                        )}

                        {!loading &&
                            typeDownload.categorias &&
                            typeDownload.categorias.map((category) => <DownloadCategory key={category.id} category={category} />)}
                    </div>
                </div>
            </div>
        </DefaultLayout>
    );
}

export default App;
